import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  backgroundColor: {
    base: 'transparent',
    md: primitive.$white,
  },
  padding: {
    base: '$0',
    md: '$6',
  },
  borderRadius: primitive.$borderRadius,
  shadow: {
    base: 'none',
    md: '1',
  },
  position: 'relative',
});

export const Header = withTypography({
  variant: 'headerOne',
  fontSize: '3xl',
  style: {},
});

export const OrderNumber = withTypography({ variant: 'copyOne', mb: '$4' });

export const Instructions = withTypography({ variant: 'copyOne', my: '$1' });
